(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-features-list"] && !Shopify.designMode) return;
  try {
    
const paragraphs = document.querySelectorAll(".immunity-poits-list p");
paragraphs.forEach(paragraph => {
    const words = paragraph.textContent.split(" ");
    if (words.length > 0) {
        words[0] =`<span style="color: #E1FDD5;">${words[0]}</span>`;
    }
    paragraph.innerHTML = words.join(" ");
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-research-product"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function() {
    // Open popup
    document.querySelectorAll('.medical_data_btn.openwhitepaper').forEach(function(openBtn){
      openBtn.addEventListener('click', function(event){
        event.preventDefault();
        const sectionId = this.getAttribute('data-id');
        const popup = document.querySelector('.popup-container[data-id="' + sectionId + '"]');
        if (popup) {
          popup.style.visibility = 'visible';
          popup.style.opacity = '1';
          document.body.classList.add('popup-open');
        }
      });
    });

    // Close popup
    document.querySelectorAll('.popup-container .close').forEach(function(closeBtn){
      closeBtn.addEventListener('click', function(event){
        event.preventDefault();
        const popup = this.closest('.popup-container');
        if (popup) {
          popup.style.visibility = 'hidden';
          popup.style.opacity = '0';
          document.body.classList.remove('popup-open');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
